import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints.ts';

import { FindOneOrganizationResponse } from '@/types/organization';

export const organizationApiSlice = createApi({
  reducerPath: 'organizationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.Organization],
  endpoints: (builder) => ({
    getOrgById: builder.query<FindOneOrganizationResponse, string>({
      query: (orgId) => ({
        url: `${API_ENDPOINTS.ORGANIZATIONS.FIND_BY_ID(orgId)}`,
        method: 'GET'
      })
    })
    // Add other endpoints here.
  })
});

export const { useGetOrgByIdQuery } = organizationApiSlice;
